import { render, staticRenderFns } from "./copyswitchmodel.vue?vue&type=template&id=4ba4cf0e&"
import script from "./copyswitchmodel.vue?vue&type=script&lang=ts&"
export * from "./copyswitchmodel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "copyswitchmodel.vue"
export default component.exports